<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">{{options?.title}}</h4>
</div>
<div class="modal-body">
    <p [innerHTML]="$safeNavigationMigration(options?.body)"></p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="ok()">{{options?.okButtonText || 'Ok'}}</button>
    <button type="button" class="btn btn-link" (click)="close()">{{options?.cancelButtonText || 'Cancel'}}</button>
</div>